import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';
import { ConversationDto } from '@/Domain/api/Conversation/dto/Conversation.dto';
import { Badge } from '@/Domain/components/Shared/Badge/Badge';
import { Separator } from '@/Domain/components/Shared/Separator/Separator';

type Props = {
  conversation: ConversationDto;
};

export const UnifiedAlerts = ({ conversation }: Props) => {
  const { t } = useTranslation('inbox_v2');

  const matched = conversation.unified_analysis?.matched_alerts ?? [];

  if (matched.length === 0) {
    return null;
  }

  return (
    <>
      <Separator />
      <div className="flex flex-col gap-2" data-testid="unified-alerts">
        <div className="flex items-center gap-2">
          <Icon icon="mingcute:alarm-2-fill" className="text-amber-500 size-4" />
          <p className="font-semibold text-foreground-subtle">
            {t('conversation_details.unified_analytics.alerts')}
          </p>
        </div>
        <div className="flex flex-wrap gap-1.5">
          {matched.map((name) => (
            <Badge key={name} variant="secondary" data-testid="unified-alert-chip">
              {name}
            </Badge>
          ))}
        </div>
      </div>
    </>
  );
};
